// Public keys and env constants for React
// Do NOT store private keys here.

export const WEB_APP_PATHS = {
	__STASH_ENV__: 'https://app-local.stash.com:57454',
	edge: 'https://app-edge.stash.com',
	staging: 'https://app-staging.stash.com',
	production: 'https://app.stash.com',
};
export const WEB_APP_PATH = WEB_APP_PATHS[window.Stash.env] || 'https://app.stash.com';

export const GOOGLE_API_KEY = 'AIzaSyB2YrG2RJrFZXpoEdDSJDm7lwtCF6Dj2yI';

export const BRAZE_API_KEYS = {
	__STASH_ENV__: 'c5ddb9e3-eef6-4fed-9cb9-f9d509a8e09b',
	edge: 'c5ddb9e3-eef6-4fed-9cb9-f9d509a8e09b',
	staging: '71380541-1bc1-4cf6-846d-799b1c824a3e',
	production: '0da29a32-e4a8-451c-83cd-f0110502629b',
};
export const BRAZE_ENV_APP_KEY = BRAZE_API_KEYS[window.Stash.env] || BRAZE_API_KEYS.prod;
export const BRAZE_SDK_ENDPOINT = 'sdk.iad-01.braze.com';

export const GOOGLE_RECAPTCHA_SITE_IDS = {
	__STASH_ENV__: '6LfPJtsUAAAAAHW2utF4dUPktbLGv3tUoyjhCYfA',
	edge: '6LfPJtsUAAAAAHW2utF4dUPktbLGv3tUoyjhCYfA',
	staging: '6LfPJtsUAAAAAHW2utF4dUPktbLGv3tUoyjhCYfA',
	production: '6LdsJ9oUAAAAAMUQ5m2PYLEZT9CyQvbqBCDwfB-3',
};
export const GOOGLE_RECAPTCHA_SITE_ID = GOOGLE_RECAPTCHA_SITE_IDS[window.Stash.env];

export const SEGMENT_WRITE_KEYS = {
	// There is a single environment for non-production environments
	__STASH_ENV__: 'tmccVDzm0quPFpPmj0BlaMNnFGflU1A7',
	edge: 'tmccVDzm0quPFpPmj0BlaMNnFGflU1A7',
	staging: 'tmccVDzm0quPFpPmj0BlaMNnFGflU1A7',
	production: 'y1IRbCVDdBnvyJ5OH0DShNFjMh6Kj9jO',
};

export const SEGMENT_WRITE_KEY = SEGMENT_WRITE_KEYS[window.Stash.env];
export const SEGMENT_CDN_PROXY_URL = 'https://analytics.stash.com/load';

export const REACTIVATION_LOCAL_STORAGE_KEY = 'hasCompletedReactivation';
export const REACTIVATION_QUERY_PARAM = 'reactivated';

export const BUY_FLOW_VIEW_TYPES = {
	BASIC_MODAL: 'basic-modal',
};

export * from './disclosures';
export * from './themes';

const launchDarklyClientIds = {
	edge: '5c4b418a30f553456b19390f',
	staging: '5c4b419b30f553456b193917',
	production: '5c4b41a40a0edd4545baef6a',
};

export const LAUNCH_DARKLY_CLIENT_IDS = {
	edge: launchDarklyClientIds.edge,
	staging: launchDarklyClientIds.staging,
	production: launchDarklyClientIds.production,

	__STASH_ENV__: launchDarklyClientIds.edge,
	stockton_dev: launchDarklyClientIds.staging,
};

export const AI_BASE_URL = import.meta.env.VITE_AI_BASE_URL;
